import {
  DetailsListLayoutMode,
  DetailsRow,
  DetailsRowCheck,
  getTheme,
  IColumn,
  Icon,
  IDetailsFooterProps,
  IDetailsRowBaseProps,
  IDetailsRowCheckStyles,
  IIconProps,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  Label,
  mergeStyleSets,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
} from '@fluentui/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { uPrinceTheme } from '../../../../../theme';
import { POResourceColumn } from '../../../../shared/tableColumn/tableColumn';
import { RESOURCE_TYPE } from '../../../../types/purchaseOrder';

const theme = getTheme();

const itemAlignmentsStackTokens: IStackTokens = {
  childrenGap: 3,
  padding: 10,
};

const iconButtonStyles = {
  root: { color: uPrinceTheme.palette.themePrimary },
  rootHovered: { color: theme.palette.neutralDark },
};

const removeIcon: IIconProps = {
  iconName: 'Delete',
  styles: iconButtonStyles,
};

const stackFooterBarItemStyles: IStackItemStyles = { root: { height: 45 } };
const saveIcon: IIconProps = { iconName: 'Save', styles: iconButtonStyles };

const TLDataGrid = (props: {
  dataList: any[];
  title: string;
  link: string;
  id: string;
  columns: any[];
  isLoaded: boolean;
  selection: any;
  setOpenPOResourceModal: () => void;
  resourceType: RESOURCE_TYPE;
  isExpand: boolean;
}) => {
  const { t } = useTranslation();
  const classNames = mergeStyleSets({
    wrapper: {
      // height: '100vh',
      position: 'relative',
      maxHeight: 'inherit',
      minHeight: (props.dataList && props.dataList.length > 1) ? 200 : 110,
    },
    pane: { maxWidth: 400 },
    textContent: { padding: '15px 10px' },
    actionIcon: {
      padding: 5,
      cursor: 'pointer',
    },
    labelRightWrapper: {
      textAlign: 'end',
      selectors: { '@media(max-width: 1100px)': { textAlign: 'start' } },
    },
    actionButton: {
      color: uPrinceTheme.palette.themePrimary,
      cursor: 'pointer',
    },
    labelRightIcon: {
      display: 'inline-block',
      verticalAlign: 'bottom',
      paddingBottom: 2,
      paddingRight: 5,
    },
  });

  useEffect(() => {
    changeColor();
  });
  const stackStyles: IStackStyles = { root: { padding: 0 } };
  const stackItemStyles: IStackItemStyles = {
    root: {
      display: 'flex',
      height: 40,
      alignItems: 'flex-start',
    },
  };

  const stackTokens: IStackTokens = {
    childrenGap: 15,
    padding: 10,
  };

  const detailsRowCheckStyles: Partial<IDetailsRowCheckStyles> = { root: { visibility: 'hidden' } };

  const _onRenderCheckForFooterRow: IDetailsRowBaseProps['onRenderCheck'] = (props): JSX.Element => {
    return <DetailsRowCheck {...props} styles={detailsRowCheckStyles} selected={true}/>;
  };

  const _onRenderCheckForHeaderRow: IDetailsRowBaseProps['onRenderCheck'] = (props): JSX.Element => {
    return <DetailsRowCheck {...props} styles={detailsRowCheckStyles} selected={true}/>;
  };

  const _onRenderDetailsHeader = (detailsFooterProps: IDetailsFooterProps): JSX.Element => {
    return (
      <DetailsRow
        {...detailsFooterProps}
        columns={detailsFooterProps.columns}
        item={{}}
        itemIndex={-1}
        groupNestingDepth={detailsFooterProps.groupNestingDepth}
        selectionMode={SelectionMode.single}
        selection={detailsFooterProps.selection}
        onRenderItemColumn={_renderDetailsHeaderItemColumn}
        onRenderCheck={_onRenderCheckForHeaderRow}
      />
    );
  };

  const _renderDetailsHeaderItemColumn: IDetailsRowBaseProps['onRenderItemColumn'] = (item, index, column) => {
    if (column && column.fieldName && (column.fieldName === 'pDocuments' || column.fieldName === 'cDocuments')) {
      return (
        <div style={{ width: 100 }}>
          <Label>&nbsp;</Label>
          {/* <Label>{i18n.t('documents')}</Label> */}
          <Icon
            iconName="WordDocument"
          />
        </div>
      );
    } else if (column && column.fieldName && (column.fieldName === 'pComments' || column.fieldName === 'cComments')) {
      return (
        <div className={'mcomments'} style={{ width: 400 }}>
          <Label>&nbsp;</Label>
          {/* <Label>{i18n.t('comments')} */}
          <Icon
            iconName="Comment"
          />

        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'borTitle')) {
      return (
        <div className={'costPerUnit'} style={{ width: 100 }}>
          <Label style={{ marginLeft: props.isExpand ? 120 : 145 }}>{t('reference')}</Label>
          <Label>{t('borTitle')}</Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pTitle' || column.fieldName === 'cTitle')) {
      return (
        <div className={'tresourceTitle'} style={{ width: 100 }}>
          <Label>&nbsp;</Label>
          <Label>{t('resourceTitle')}</Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pdevices' || column.fieldName === 'cdevices')) {
      return (
        <div className={'totalCost1'} style={{ width: 100 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('devices')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pFullTimeEmployee' || column.fieldName === 'cFullTimeEmployee')) {
      return (
        <div className={'totalCost1'} style={{ width: 100 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('fTE')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pNumberOfDate' || column.fieldName === 'cNumberOfDate')) {
      return (
        <div className={'totalCost1'} style={{ width: 100 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('numberofDays')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pStartDate' || column.fieldName === 'cStartDate')) {
      return (
        <div className={'totalCost1'} style={{ width: 400 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('startDate')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pStopDate' || column.fieldName === 'cStopDate')) {
      return (
        <div className={'totalCost1'} style={{ width: 400 }}>
          <Label>{t('article')}</Label>
          <Label>
            {t('stopDate')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pQuantity' || column.fieldName === 'cQuantity')) {
      return (
        <div className={'totalCost1'} style={{ width: 400 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('quantity')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pMou' || column.fieldName === 'cMou')) {
      return (
        <div className={'mmou'} style={{ width: 400 }}>
          <Label>&nbsp;</Label>
          <Label>
            {t('mou')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pUnitPrice' || column.fieldName === 'cUnitPrice')) {
      return (
        <div style={{ width: 400 }}>

          <Label style={{ marginLeft: props.isExpand ? 58 : 100 }}>{t('finance')}</Label>
          <Label style={{ marginLeft: (true) ? 30 : 10 }}>
            {t('unitPrice')}
          </Label>
        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'pTotalPrice' || column.fieldName === 'cTotalPrice')) {
      return (
        <div style={{ width: 100, textAlign: 'left' }}>

          <Label>&nbsp;</Label>
          <Label style={{ marginLeft: 20 }}>
            {t('totalPrice')}
          </Label>

        </div>
      );
      return null;
    } else if (column && column.fieldName && (column.fieldName === 'requestedDate')) {
      return (
        <div style={{ width: 180, textAlign: props.isExpand ? 'center' : 'left' }}>
          <Label>&nbsp;</Label>
          <Label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t('requestedDeliveryDate')}
          </Label>
        </div>
      );
      return null;
    } else {
      return null;
    }

  };

  const changeColor = () => {
    let cquantityClass = document.getElementsByClassName('mcomments');
    for (let i = 0; i < cquantityClass.length; i++) {
      let parentElement = cquantityClass[i].parentElement;
      if (parentElement) {
        parentElement.style.borderRight = '1px solid rgb(243, 242, 241)';
      }
    }

    let tresourceTitle = document.getElementsByClassName('tresourceTitle');
    for (let i = 0; i < tresourceTitle.length; i++) {
      let parentElement = tresourceTitle[i].parentElement;
      if (parentElement) {
        parentElement.style.borderRight = '1px solid rgb(243, 242, 241)';
      }
    }
    let totalCost1Class = document.getElementsByClassName('mmou');
    for (let i = 0; i < totalCost1Class.length; i++) {
      let parentElement = totalCost1Class[i].parentElement;
      if (parentElement) {
        parentElement.style.borderRight = '1px solid rgb(243, 242, 241)';
      }
    }

  };

  return (
    <div className={'document-pane-card  purchase-order'}>
      <div className={'card-header'}>
        <div className="sub-header-title">
          <Stack
            horizontal
            horizontalAlign="space-between"
            styles={stackStyles}
            tokens={stackTokens}
          >
            <Stack.Item styles={stackItemStyles}>
              <Label
                id={props.link}
                style={{ marginTop: 10, fontSize: '1.1rem' }}
              >
                {props.id}. {props.title}
              </Label>
            </Stack.Item>

          </Stack>
        </div>
      </div>

      <div className={'card-body'}>
        <div className="proj-detail-block" id={props.id}>
          <div className="marginTop">
            <div style={{ padding: 12 }}>
              <div className="ms-Grid-row marginTop">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <div className={classNames.wrapper}>
                    <div className={'scrollablePane'}>
                      {/*<ScrollablePane styles={ { root: { height: 'auto' } } }>*/}
                      <ShimmeredDetailsList
                        items={props.dataList}
                        columns={props.columns}
                        setKey="set"
                        enableShimmer={props.isLoaded}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionPreservedOnEmptyClick={true}
                        checkboxVisibility={1}
                        //onItemInvoked={ () => { props.setOpenPOResourceModal();} }
                        onRenderItemColumn={(
                          item: any,
                          index?: number,
                          column?: IColumn,
                        ) =>
                          POResourceColumn(
                            props.resourceType,
                            item,
                            index,
                            column,
                          )
                        }
                        selection={props.selection}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        checkButtonAriaLabel="Row checkbox"
                        onRenderDetailsHeader={(props) => _onRenderDetailsHeader(props!!)}
                        // onRenderDetailsHeader={ (headerProps, defaultRender) => {
                        //     if (defaultRender !== undefined) {
                        //         return (
                        //             <Sticky
                        //                 stickyPosition={ StickyPositionType.Header }
                        //                 isScrollSynced={ true }
                        //                 stickyBackgroundColor="transparent"
                        //             >
                        //                 <div>{ defaultRender(headerProps) }</div>
                        //             </Sticky>
                        //         );
                        //     }
                        //     return <span></span>;
                        // } }
                        onRowDidMount={() => {
                          changeColor();
                        }}
                      />
                      {/*</ScrollablePane>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'card-footer'}>
        { /* <Separator />*/}
        { /* <Stack styles={stackStyles} tokens={itemAlignmentsStackTokens}>*/}
        { /* <Stack.Item align="end" styles={stackFooterBarItemStyles}>*/}
        { /* <ActionButton*/}
        { /* className={classNames.actionButton}*/}
        { /* iconProps={saveIcon}*/}
        { /* allowDisabledFocus*/}
        { /* onClick={() => {*/}
        { /* props.saveFormData();*/}
        { /* }}*/}
        { /* >*/}
        { /* <Label className={classNames.actionButton}>{t('save')} </Label>*/}
        { /* </ActionButton>*/}
        { /* </Stack.Item>*/}
        { /* </Stack>*/}
      </div>
    </div>
  );
};

export default TLDataGrid;
